var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoadingTrends)?_c('gl-loading-icon',{staticClass:"gl-mt-6",attrs:{"size":"lg"}}):_c('div',[_c('security-training-promo-banner'),_vm._v(" "),_c('gl-line-chart',{staticClass:"gl-mt-6",attrs:{"data":_vm.dataSeries,"option":_vm.chartOptions,"responsive":"","include-legend-avg-max":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }